import LocalizedStrings from 'react-localization';

import de from '@/i18n/language.de';
import en from '@/i18n/language.en';
import es from '@/i18n/language.es';
import hu from '@/i18n/language.hu';
import id from '@/i18n/language.id';
import ja from '@/i18n/language.ja';
import ko from '@/i18n/language.ko';
import pt from '@/i18n/language.pt';
import th from '@/i18n/language.th';
import vi from '@/i18n/language.vi';
import zh_cn from '@/i18n/language.zh-cn';
import zh_tw from '@/i18n/language.zh-tw';

export const LanguageCode = {
  EN: 'en',
  ES: 'es',
  PT: 'pt',
  ID: 'id',
  DE: 'de',
  KO: 'ko',
  JA: 'ja',
  ZH_CN: 'zh-cn',
  ZH_TW: 'zh-tw',
  VI: 'vi',
  TH: 'th',
  HU: 'hu',
} as const;

export type LanguageCodes = (typeof LanguageCode)[keyof typeof LanguageCode];

const defaultLanguage = ko;

const strings = new LocalizedStrings({
  [LanguageCode.EN]: Object.assign({}, defaultLanguage, en),
  [LanguageCode.ES]: Object.assign({}, defaultLanguage, es),
  [LanguageCode.PT]: Object.assign({}, defaultLanguage, pt),
  [LanguageCode.ID]: Object.assign({}, defaultLanguage, id),
  [LanguageCode.DE]: Object.assign({}, defaultLanguage, de),
  [LanguageCode.KO]: ko,
  [LanguageCode.JA]: Object.assign({}, defaultLanguage, ja),
  [LanguageCode.ZH_CN]: Object.assign({}, defaultLanguage, zh_cn),
  [LanguageCode.ZH_TW]: Object.assign({}, defaultLanguage, zh_tw),
  [LanguageCode.VI]: Object.assign({}, defaultLanguage, vi),
  [LanguageCode.TH]: Object.assign({}, defaultLanguage, th),
  [LanguageCode.HU]: Object.assign({}, defaultLanguage, hu),
});

export function languageName(languageCode: string): string {
  switch (languageCode) {
    case LanguageCode.EN:
      return 'English';
    case LanguageCode.ES:
      return 'Español';
    case LanguageCode.PT:
      return 'Português';
    case LanguageCode.DE:
      return 'Deutsch';
    case LanguageCode.KO:
      return '한국어';
    case LanguageCode.ID:
      return 'Bahasa Indonesia';
    case LanguageCode.JA:
      return '日本語';
    case LanguageCode.ZH_CN:
      return '中文(简体)';
    case LanguageCode.ZH_TW:
      return '中文(繁體)';
    case LanguageCode.VI:
      return 'Tiếng Việt';
    case LanguageCode.TH:
      return 'ไทย';
    case LanguageCode.HU:
      return 'Magyar';

    default:
      return 'Unknown';
  }
}

export default strings;
